export const dateFormatter = date => date?.split("-").reverse().join(".")

export const categoriesFormatter = categories =>
  categories.map(category => category.name).join(",")

export const containsCurrentCategory = (filterCategory, articleCategories) => {
  let categories = articleCategories

  if (typeof articleCategories === "string") {
    categories = articleCategories.split(",")
  } else {
    categories = categories.map(category => category.name)
  }

  return categories.includes(filterCategory)
}
